// core feature do not remove this line
import PluginController from './plugin-core-system/plugin.controller.js';

// import essentials
import CsPhoneLinks from './essentials/cs-phone-links.js';
import CsExternalLinks from './essentials/cs-external-links.js';
import CsScrollbar from './essentials/cs-scrollbar.js';

// import external plugins
import 'lazysizes/plugins/respimg/ls.respimg.js';
import 'lazysizes';


// import custom plugins
import CsModalManager from './plugins/cs-modal-manager.js';
import CsMainNavigation from './plugins/cs-main-navigation.js';
import CsFormFields from './plugins/cs-form-fields.js';
import CsSplide from './plugins/cs-splide.js';
import CsResponsiveVideo from './plugins/cs-responsive-video.js';
import CsAccordion from './plugins/cs-accordion.js';
import CsResponsiveTables from './plugins/cs-responsive-tables.js';
import CsLightbox from './plugins/cs-lightbox.js';
import CsScrollToTop from './plugins/cs-to-top-button.js';
import CsAccessibilityAnimation from './plugins/cs-accessibility-animation.js';
import CsCookieBannerRenderer from './plugins/cs-cookie-banner-renderer.js';
import CsCookieBannerHandler from './plugins/cs-cookie-banner-handler.js';
import CsCookieBannerCustomFunctions from './plugins/cs-cookie-banner-custom-functions.js';
import CsCountrySelection from './plugins/cs-country-selection.js';
import CsSectionMenu from './plugins/cs-section-menu.js';
import CsGlobal from './plugins/cs-global.js';

// register plugins for initializing
PluginController.addPlugin('CsModalManager', CsModalManager);

PluginController.addPlugin('CsPhoneLinks', CsPhoneLinks, 'a[href^="tel:"]');
PluginController.addPlugin('CsExternalLinks', CsExternalLinks, 'a[target="_blank"]');

PluginController.addPlugin('CsScrollbar', CsScrollbar);
PluginController.addPlugin('CsMainNavigation', CsMainNavigation, '.js-menu-main');
PluginController.addPlugin('CsSplide', CsSplide, '.js-slider');
PluginController.addPlugin('CsFormFields', CsFormFields);
PluginController.addPlugin('CsResponsiveVideo', CsResponsiveVideo);
PluginController.addPlugin('CsAccordion', CsAccordion, '.js-accordion');
PluginController.addPlugin('CsResponsiveTables', CsResponsiveTables, 'table');
PluginController.addPlugin('CsResponsiveTables', CsResponsiveTables, 'table.price-table__table');
PluginController.addPlugin('CsLightbox', CsLightbox);
PluginController.addPlugin('CsScrollToTop', CsScrollToTop, '.js-scroll-to-top');
PluginController.addPlugin('CsAccessibilityAnimation', CsAccessibilityAnimation, '.js-toggle-animations');
PluginController.addPlugin('CsCookieBannerRenderer', CsCookieBannerRenderer, '.js-cscb-edit-box');
PluginController.addPlugin('CsCookieBannerHandler', CsCookieBannerHandler, '.js-cscb-edit-box');
PluginController.addPlugin('CsCookieBannerCustomFunctions', CsCookieBannerCustomFunctions);
PluginController.addPlugin('CsCountrySelection', CsCountrySelection, '.js-country-selection');
PluginController.addPlugin('CsSectionMenu', CsSectionMenu, '.js-section-menu');
PluginController.addPlugin('CsGlobal', CsGlobal);

//PluginController.addPlugin('pluginCsAjax', pluginCsAjax);

// core feature must be placed at the bottom of this script
document.addEventListener('DOMContentLoaded',
  () => PluginController.initializeAllPlugins(), false);
